import React, { Component } from "react";
import { Button } from "antd";
import styled from "styled-components";

const ApproveButton = styled(Button)`
  && {
    border: none;
    outline: none;
    background: transparent !important;
    box-shadow: none;
    color: #40a9ff;
    padding: 0;

    :active, :focus:, :hover {
      border: none;
      outline: none;
      background: transparent !important;
      box-shadow: none;
    }
  }
`;

const getApprovalByRole = (role, approval, formId, showModal) => {
  switch (role) {
    case "AED_MANAGER_1":
    case "AED_MANAGER_2":
    case "AED_MANAGER_3":
    case "AED_MANAGER_4":
    case "HS_MANAGER_1":
    case "HS_OPS_MANAGER":
    case "CASE_MANAGER_1":
    case "CASE_MANAGER_2":
    case "CASE_MANAGER_3":
    case "CASE_MANAGER_4":
    case "SAFE_MANAGER_1":
      if (approval.length === 1) {
        return (
          <span>
            <ApproveButton onClick={() => showModal("approve", formId)}>
              Approve
            </ApproveButton>
          </span>
        );
      } else if (approval.length === 2) {
        return <span>Awaiting Approval</span>;
      } else if (approval.length > 2) {
        return <span>Approved</span>;
      }

    case "HS_ASSISTANT_DIR_OPS":
      if (
        approval.find(
          approver =>
            approver["approvingAuthority"] === "head_start_center_manager"
        )
      ) {
        if (approval.length === 1) {
          return <span>Awaiting Approval</span>;
        } else if (approval.length === 2) {
          return (
            <span>
              <ApproveButton onClick={() => showModal("approve", formId)}>
                Approve
              </ApproveButton>
            </span>
          );
        } else if (approval.length === 3) {
          return <span>Approved</span>;
        }
      } else {
        if (approval.length === 1) {
          return (
            <span>
              <ApproveButton onClick={() => showModal("approve", formId)}>
                Approve
              </ApproveButton>
            </span>
          );
        } else if (approval.length === 2) {
          return <span>Approved</span>;
        }
      }

    case "CASE_DIR_COMPLIANCE":
      if (
        approval.find(
          approver =>
            approver["approvingAuthority"] ===
              "case_21_century_assistant_director" ||
            approver["approvingAuthority"] ===
              "case_partnership_assistant_director" ||
            approver["approvingAuthority"] ===
              "case_city_of_houston_assistant_director" ||
            approver["approvingAuthority"] ===
              "case_endowment_assistant_director"
        )
      ) {
        if (approval.length === 1) {
          return (
            <span>
              <ApproveButton onClick={() => showModal("approve", formId)}>
                Approve
              </ApproveButton>
            </span>
          );
        } else if (approval.length === 2) {
          return <span>Approved</span>;
        }
      } else {
        if (approval.length === 1) {
          return <span>Awaiting Approval</span>;
        } else if (approval.length === 2) {
          return (
            <span>
              <ApproveButton onClick={() => showModal("approve", formId)}>
                Approve
              </ApproveButton>
            </span>
          );
        } else if (approval.length > 2) {
          return <span>Approved</span>;
        }
      }

    case "AED_DIR_COMPLIANCE":
    case "HS_DIR_COMPLIANCE":
    case "SAFE_DIR_COMPLIANCE":
      if (approval.length === 1) {
        return <span>Awaiting Approval</span>;
      } else if (approval.length === 2) {
        return (
          <span>
            <ApproveButton onClick={() => showModal("approve", formId)}>
              Approve
            </ApproveButton>
          </span>
        );
      } else if (approval.length > 2) {
        return <span>Approved</span>;
      }

    case "HS_SENIOR_DIRECTOR":
      if (approval.length === 1) {
        return (
          <span>
            <ApproveButton onClick={() => showModal("approve", formId)}>
              Approve
            </ApproveButton>
          </span>
        );
      } else if (approval.length === 2) {
        return <span>Approved</span>;
      }

    case "AED_SAFE_ELT":
    case "HS_ELT":
    case "CASE_ELT":
      if (approval.length === 1) {
        return (
          <span>
            <ApproveButton onClick={() => showModal("approve", formId)}>
              Approve
            </ApproveButton>
          </span>
        );
      } else if (approval.length === 2) {
        return <span>Approved</span>;
      }

    default:
      return <span>Approve</span>;
  }
};

const CustomApproval = ({ role, approval, formId, showModal }) => {
  return getApprovalByRole(role, approval, formId, showModal);
};

export default CustomApproval;
